import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** "NetPing" device create and update APIs request body - DTO signature */
export interface NetPingDeviceFormInterface {
  /** Device display name */
  name: string;
  /** Device IP-address */
  ipAddress: string;
  /** Lock indicator channel value OID */
  lockIndicatorOid: string;
  /** Lock indicator channel number */
  lockIndicatorNumber: number;
  /** Lock value OID */
  lockValueOid: string;
  /** Value which marks device as locked */
  lockValue: number;
}

/** "NetPing" device create and update APIs request body - DTO schema */
export const NetPingDeviceFormDto = SerdeDtoClass.create<NetPingDeviceFormInterface>(PacsDtoKeysEnum.NET_PING_DEVICE_FORM_DTO, {
  name: {
    sortable: true,
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  ipAddress: {
    sortable: true,
    label: 'IP-адрес устройства',
    serializer: nonEmptyStringSchema,
  },
  lockIndicatorOid: {
    label: 'OID значения с номером линии блокировки',
    serializer: nonEmptyStringSchema,
  },
  lockIndicatorNumber: {
    label: 'Номер линии блокировки, который надо прослушивать',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE)
      .integer(DtoMessageEnum.NOT_INTEGER),
  },
  lockValueOid: {
    label: 'OID флага блокировки',
    serializer: nonEmptyStringSchema,
  },
  lockValue: {
    label: 'Значение флага блокировки, при котором устройство считается заблокированным',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE)
      .integer(DtoMessageEnum.NOT_INTEGER),
  },
});
